<template>
  <v-row class="mb-10" v-if="list">
    <v-col cols="12"> </v-col>
    <v-col cols="6">
      <h2 v-text="$t('exercise_archetypes.step1.title')"></h2>
    </v-col>
    <v-col cols="6">
      <p
        v-for="(item, index) in $t('exercise_archetypes.step1.description')"
        :key="index"
        v-text="item"
      />
    </v-col>
    <v-col cols="6" sm="3" md="3" lg="3" v-for="card in list" :key="card.id">
      <v-card
        class="mx-auto card--fade"
        :data-id="card.id"
        :class="{ selected: card.selected }"
        @click="selectCard(card.id)"
        light
      >
        <!-- <v-img class="white--text align-end" :src="card.src"> </v-img> -->
        <div
          class="archetype__inner"
          :style="{ backgroundImage: `url(${card.src})` }"
        ></div>
        <v-card-title>{{ card.name }}</v-card-title>
        <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src
import lodash from "lodash";

export default {
  name: "ArchetypesTiles",
  props: {
    list: Array,
    value: Array,
    exercise: Object,
    selectedList: Array,
  },
  data() {
    return {
      shortlist: [],
      refList: null,
    };
  },
  watch: {
    exercise(val) {
      if (val) {
        this.createList();
      }
    },
    selectedList: {
      deep: true,
      handler(val) {
        if (val.length) {
          this.selectCard(val[0]);
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.createList();
    });
  },
  methods: {
    selectCard(id) {
      this.resetCards();
      let vm = this;
      let item = this.list.find((item) => item.id === id);
      let indexOfItem = this.list.indexOf(item);
      let truthy = item.selected;
      item.selected = !truthy;
      vm.$set(vm.list, indexOfItem, item);
      this.updateShortList(item);
    },
    updateShortList(item) {
      this.shortlist = [];
      if (item.selected == true) {
        this.shortlist.push(item);
      } else {
        this.shortlist = [];
      }
      this.$emit("input", this.shortlist);
    },
    resetCards() {
      let vm = this;
      let count = 0;
      this.list.forEach(() => {
        let item = vm.list[count];
        item.selected = false;
        vm.$set(vm.list, count, item);
        count++;
      });
    },
    createList() {
      console.log("create list", this.list);
      let list = this.list;
      let count = 0;
      list.forEach((item) => {
        item.selected = this.checkId(item.id);
        item.index = count;
        count++;
      });
      this.list = list;
      this.createShortlist();
    },
    createShortlist() {
      let l = this.list.filter((item) => item.selected == true);
      this.shortlist = lodash.orderBy(l, "index", "asc");
      this.$emit("input", this.shortlist);
    },
    checkId(id) {
      if (this.exercise) {
        let filteredList = this.exercise.doc.archetype.some(
          (item) => item.id == id
        );
        return filteredList ? true : false;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.archetype {
  &__inner {
    // display: flex;
    margin: 0px;
    // align-items: center;
    // justify-content: center;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    font-size: 2rem;
    color: black;
    background-color: white;
    background-size: cover;
    background-position: center;
    position: relative;
    // border: 4px solid white !important;
    transition: all 0.3s ease-out;
    .img {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      content: "";
      width: 100%;
      height: 100%;
      // background-color: rgba(255, 193, 7, 0);
      transition: all 0.3s ease-out;
      z-index: 1;
    }
    &__text {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      h2 {
        font-size: 2rem;
      }
    }
  }
}
</style>
